module.exports = __webpack_public_path__ + "img/F79686_FCCBD4_E76644_E76B56-256px.409eec49.png";